module.exports = __webpack_public_path__ + "media/piece-move-sound-effect.51813c7c.mp3";